export var hexToRgb = function (hex) {
    hex = hex.replace(/^#/, "");
    var bigint = parseInt(hex, 16);
    var r = (bigint >> 16) & 255;
    var g = (bigint >> 8) & 255;
    var b = bigint & 255;
    return "".concat(r, ", ").concat(g, ", ").concat(b);
};
/**
 * Lightens a hex color by a given percentage towards white.
 *
    const original = "#E31937";
    const lightened = lightenColor(original, 0.85); // 85% towards white
    console.log(lightened); // Output: ~#FFE4E8
 */
export function lightenColor(hex, percent) {
    var num = parseInt(hex.replace("#", ""), 16);
    var r = (num >> 16) + Math.round((255 - (num >> 16)) * percent);
    var g = ((num >> 8) & 0x00ff) + Math.round((255 - ((num >> 8) & 0x00ff)) * percent);
    var b = (num & 0x0000ff) + Math.round((255 - (num & 0x0000ff)) * percent);
    return ("#" +
        ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase());
}
